// extracted by mini-css-extract-plugin
module.exports = {"PanelAlt":"PanelAlt_PanelAlt__3pBK1","corners":"PanelAlt_corners__1eZv1","grow":"PanelAlt_grow__1_71Q"};